export default class AdvancedTooltip {
  constructor() {
    this.init();
  }
  init() {

    let mouseX;
    let mouseY;

    $(document).mousemove( function(e) {
       // mouse coordinates
       mouseX = e.pageX;
       mouseY = e.pageY;
    });

    $(".esf-advanced-tooltip").appendTo("body");

    // hover
    $(".-has-advanced-tooltip").mouseover(function(){

        // Get tooltip text
        let tooltipText = $(this).attr("data-advanced-tooltip");

        // Populate tooltip string
        $(".esf-advanced-tooltip__text").html(tooltipText);

        // show tooltip
        $(".esf-advanced-tooltip").stop(false, true).fadeIn(1);

        // Calculate position
        let tooltipX = $("esf-advanced-tooltip").outerWidth();
        let tooltipY = $("esf-advanced-tooltip").outerHeight();
        console.log(tooltipX, tooltipY);
        let posX = mouseX - tooltipX;
        let posY = mouseY - tooltipY;

        // position tooltip relative to mouse coordinates
        $(this).mousemove(function() {
          $(".esf-advanced-tooltip").css({"top": mouseY - 48, "left": mouseX});
        });
     }).mouseout(function() {
      // hide tooltip
      $(".esf-advanced-tooltip").stop(false, true).fadeOut("slow");
    });

  }
}
